((Modal, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.modals = $('[data-modal]');
    $dom.modalClose = $('[data-modal-close]');
    $dom.modalOpen = $('[data-modal-open]');
  };

  const bindUIActions = () => {
    $(document).keydown(function (e) {
      // Escape key should close all modals
      if (e.keyCode === 27) {
        $dom.modals.each((index, el) => {
          $(el).find('a[data-modal-close]').click();
        });
      }
    });
    $dom.modalClose.on('click', function(event) {
      event.preventDefault();
      if (!($(this).attr('disabled'))) {
        const $modal = hide($(this).attr('data-modal-close'));
      }
    });
   
    $dom.modalOpen.on('click', function(event) {
      event.preventDefault();
      const $modal = show($(this).attr('data-modal-open'));

      $modal.find(`img[data-src], img[data-srcset]`).each((idx, image) => {
        if (image.classList.contains(`lazy`)) return;
        image.classList.add(`lazy`);
      });

      if (!myLazyLoad) return;
      myLazyLoad.update();
    });
  };

  const show = (modalName) => {
    return $('[data-modal=' + modalName +']').addClass('is-active');
  };

  const hide = (modalName) => {
    return $('[data-modal="' + modalName +'"]').removeClass('is-active');
  };
  
  const init = () => {
    cacheDom();
    bindUIActions();
  };

  Modal.init = init;
  Modal.show = show;
  Modal.hide = hide;
})(window.Modal = window.Modal || {}, jQuery);
